import { Button } from "@svea/design-system-components-react";
import type { ProductSkuValue } from "@sveabank/cc-common";
import { ButtonGroup, Dialog, useText } from "@sveabank/cc-common";

type Props = {
	isOpen: boolean;
	setOpen: (isOpen: boolean) => void;
	onRemove: () => Promise<void>;
	sku: ProductSkuValue;
	isLoadingRemoveAddon: boolean;
};

const RemoveCreditProductModal = ({
	isOpen,
	setOpen,
	onRemove,
	sku,
	isLoadingRemoveAddon,
}: Props) => {
	const [t, texts] = useText();

	const addonTexts = texts.addons[sku];

	return (
		<Dialog
			isOpen={isOpen}
			setOpen={setOpen}
			center
			size="small"
			heading={"removeTitle" in addonTexts ? t(addonTexts.removeTitle) : ""}
		>
			<Dialog.Content>
				{"removeDescription" in addonTexts ? t(addonTexts.removeDescription) : ""}
			</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					<Button onPress={onRemove} isPending={isLoadingRemoveAddon}>
						{t(texts.common.remove)}
					</Button>
					<Button variant="secondary" type="button" width="full" onPress={() => setOpen(false)}>
						{t(texts.common.abort)}
					</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};

export default RemoveCreditProductModal;
